module.exports = __webpack_public_path__ + "static/media/card-seleto.c0528626.png";